import { Directive, Input, Inject, Optional, inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from '../../services/notification.service';

@Directive()
export abstract class BaseFormComponent {
  @Input() mode: 'page' | 'modal' | 'panel' = 'page';
  form: UntypedFormGroup;
  protected notification = inject(NotificationService);

  constructor(
    protected dialog: MatDialog,
    protected snackBar: MatSnackBar,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: any,
  ) {
    if (data && data.mode) {
      this.mode = data.mode;
    }
  }

  getColumnClass(): string {
    if (this.mode === 'page') return 'col-xs-12 col-md-3 col-lg-3';
    if (this.mode === 'modal') return 'col-xs-12 col-md-3';
    if (this.mode === 'panel') return 'col-12';
    return 'col-12';
  }

  expandToDialog(component: any): void {
    this.dialog.open(component, {
      width: '90vw',
      height: '90vh',
      data: {
        mode: 'modal',
        formValue: this.form.value
      }
    });
  }

  showMessage(message: string, action: string, type: 'success' | 'warn' | 'error') {
    if (type === 'success') this.notification.okBottom(message);
    else if (type === 'warn') this.notification.warningBottom(message);
    else this.notification.errorBottom(message);
  }
}
